var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    "data-name": "Group 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 223.55,
    height: 143.529,
    viewBox: "0 0 223.55 143.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M680.768,134.861l9.692-7.752c-7.53-.831-10.623,3.276-11.889,6.526-5.882-2.443-12.286.759-12.286.759l19.393,7.04A14.674,14.674,0,0,0,680.768,134.861Z",
    transform: "translate(-483.244 -127)",
    fill: "#e4e4e4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M650.536,150.634l9.692-7.752c-7.529-.831-10.623,3.276-11.889,6.526-5.882-2.443-12.286.759-12.286.759l19.393,7.04a14.673,14.673,0,0,0-4.909-6.573Z",
    transform: "translate(-500.05 -118.232)",
    fill: "#e4e4e4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M680.768,175.608l9.692-7.752c-7.53-.831-10.623,3.276-11.889,6.526-5.882-2.443-12.286.759-12.286.759l19.393,7.04a14.674,14.674,0,0,0-4.909-6.573Z",
    transform: "translate(-483.244 -104.349)",
    fill: "#e4e4e4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0 23.724)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 29.202,
    cy: 29.202,
    rx: 29.202,
    ry: 29.202,
    transform: "translate(23.018 0.617)",
    fill: "#ff6583"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M692.434,262.051H549.177a2.929,2.929,0,0,1-.536-.042L616.4,144.656a4.743,4.743,0,0,1,8.257,0l45.47,78.75,2.178,3.768Z",
    transform: "translate(-548.642 -142.248)",
    fill: "#ED9C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M736.589,249.7h-123.9L636.7,214.823l1.727-2.513,31.286-45.447a6.33,6.33,0,0,1,9.4-.562,5.657,5.657,0,0,1,.451.561Z",
    transform: "translate(-513.039 -129.893)",
    fill: "#ed9c26"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.d1aac958225a4d1b49aecbdfe913d18f.svg";
export { ForwardRef as ReactComponent };